import { MutationOptions, useMutation } from "react-query";
import { API_URL, APIError, APIResponse, post } from "../api";

function useChangePin<T>(
  options?: MutationOptions<
    APIResponse<T>,
    APIError,
    { pin: string; password: string }
  >
) {
  const {
    mutate: createPin,
    isLoading: creatingPin,
    isError: isCreatePinError,
    error: createPinError,
  } = useMutation(
    async (variables) =>
      await post(API_URL + "/account/user/security/change-pin", variables, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    createPin,
    creatingPin,
    isCreatePinError,
    createPinError,
  };
}

export default useChangePin;
